module.exports = __webpack_public_path__ + "assets/blob-2.6abfebbc.svg";